import { useRef } from 'react';

const featuredItems = [
  {
    id: 'item-1',
        image: '/images/ll1.jpg',
  },
  {
    id: 'item-2',
      image: '/images/l2.jpg',
  },
  {
    id: 'item-3',
      image: '/images/l5.jpg',
  },
  {
    id: 'item-4',
      image: '/images/l3.jpg',
  },
  {
    id: 'item-5',
      image: '/images/l4.jpg',
  },
  {
    id: 'item-6',
      image: '/images/l6.jpg',
  },
];

export default function FeaturedItems() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (!scrollRef.current) return;
    const scrollAmount = 320;
    scrollRef.current.scrollBy({
      left: direction === 'left' ? -scrollAmount : scrollAmount,
      behavior: 'smooth',
    });
  };

  return (
    <section className="py-12 md:py-16" style={{ backgroundColor: '#2a4a7c' }}>
      <div className="w-full px-4 md:px-8">
        {/* Headline */}
        <h2 className="font-heading text-3xl sm:text-4xl md:text-[42px] text-white text-center tracking-[0.3em] mb-8 md:mb-12">
          FEATURED ITEMS
        </h2>

        {/* Carousel */}
        <div className="relative">
          {/* Left arrow */}
          <button
            onClick={() => scroll('left')}
            className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center text-white hover:text-primary-300 transition-colors"
            aria-label="Previous items"
          >
            <i className="ri-arrow-left-s-line text-2xl md:text-3xl" />
          </button>

          {/* Scroll container */}
          <div
            ref={scrollRef}
            className="flex gap-4 md:gap-6 overflow-x-auto scrollbar-hide px-8 md:px-12 py-4"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {featuredItems.map((item) => (
              <div
                key={item.id}
                className="flex-shrink-0 w-[250px] md:w-[300px] group cursor-pointer"
              >
                <div className="relative aspect-square overflow-hidden bg-primary-700">
                  <img
                    src={item.image}
                    alt="Featured seafood item"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              </div>
            ))}
          </div>

          {/* Right arrow */}
          <button
            onClick={() => scroll('right')}
            className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center text-white hover:text-primary-300 transition-colors"
            aria-label="Next items"
          >
            <i className="ri-arrow-right-s-line text-2xl md:text-3xl" />
          </button>
        </div>
      </div>
    </section>
  );
}